import { Banner, BannerSubtitle, BannerTitle } from './HighlightBanner.styles';

type HighlightBannerProps = {
  title: string;
  subtitle: string;
};

export default function HighlightBanner({
  title,
  subtitle
}: HighlightBannerProps) {
  return (
    <div className="flex justify-center">
      <Banner>
        <BannerTitle>{title}</BannerTitle>
        <BannerSubtitle>{subtitle}</BannerSubtitle>
      </Banner>
    </div>
  );
}
